module.exports = __webpack_public_path__ + "img/eritrea.e08875ad.png";